import { create } from 'zustand';
import type { Notification } from '@/types/api.types';

interface NotificationState {
  notifications: Notification[];
  unreadCount: number;
  isOpen: boolean;

  setNotifications: (items: Notification[]) => void;
  addNotification: (item: Notification) => void;
  markRead: (id: string) => void;
  markAllRead: () => void;
  setOpen: (open: boolean) => void;
}

export const useNotificationStore = create<NotificationState>()((set) => ({
  notifications: [],
  unreadCount: 0,
  isOpen: false,

  setNotifications: (items) =>
    set({ notifications: items, unreadCount: items.filter((n) => !n.read).length }),

  addNotification: (item) =>
    set((s) => {
      const exists = s.notifications.some((n) => n.id === item.id);
      if (exists) return s;
      const next = [item, ...s.notifications];
      return { notifications: next, unreadCount: next.filter((n) => !n.read).length };
    }),

  markRead: (id) =>
    set((s) => {
      const next = s.notifications.map((n) => (n.id === id ? { ...n, read: true } : n));
      return { notifications: next, unreadCount: next.filter((n) => !n.read).length };
    }),

  markAllRead: () =>
    set((s) => ({
      notifications: s.notifications.map((n) => ({ ...n, read: true })),
      unreadCount: 0,
    })),

  setOpen: (open) => set({ isOpen: open }),
}));
